// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { scroll as _scroll } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the scroll chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 534352
 * Chain Name: Scroll
 * Default Block Explorer: https://scrollscan.com
 * Default RPC URL: https://rpc.scroll.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { scroll } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: scroll,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const scroll = createCommon({
	..._scroll,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
